import React from "react";
import { Navigate } from "react-router-dom";

export default function JobDetail() {
  return <Navigate to="/career" replace />;
}